import React from 'react';
import { DocumentCard } from './DocumentCard';
const mockDocuments = [{
  id: 1,
  title: 'Manual de Procedimientos 2024',
  type: 'pdf',
  status: 'active',
  date: '2024-01-15',
  size: '2.5 MB',
  url: 'https://example.com/doc1.pdf'
}, {
  id: 2,
  title: 'Presentación Trimestral Q4',
  type: 'presentation',
  status: 'active',
  date: '2024-01-10',
  size: '5.8 MB',
  url: 'https://example.com/doc2.pptx'
}, {
  id: 3,
  title: 'Video Tutorial - Nuevo Sistema',
  type: 'video',
  status: 'active',
  date: '2024-01-05',
  size: '15.2 MB',
  url: 'https://example.com/video1.mp4'
}];
export const DocumentGrid = ({
  onPreview
}) => {
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-439">
      {mockDocuments.map(document => <DocumentCard key={document.id} document={document} onPreview={() => onPreview(document)} data-id="element-440" />)}
    </div>;
};